// Import this file to access our Rails routes
// See README-FRONTEND (Rails Routes) and generate_js_routes.rake

/* eslint-disable import/no-duplicates */
// Workaround for the format generated by js-routes
import routesForBrowser from "./generatedByServer";
import { Routes as routesForNode } from "./generatedByServer";
/* eslint-enable import/no-duplicates */

export default routesForNode || routesForBrowser;
